module.exports = "/images/angelin.jpg?d95c3baf20e0675527d0356748a6e5a1";